import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import LoginForm from "../components/auth/LoginForm";
import loginImage from "../assets/images/1.png";

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // 🔑 mobile detection

  const [openLogin, setOpenLogin] = useState(isMobile);
  const autoOpenRef = useRef(null);

  /* AUTO OPEN ONLY FOR DESKTOP */
  useEffect(() => {
    if (isMobile) return;

    autoOpenRef.current = setTimeout(() => {
      setOpenLogin(true);
    }, 3000);

    return () => clearTimeout(autoOpenRef.current);
  }, [isMobile]);

  const handleLoginClick = () => {
    clearTimeout(autoOpenRef.current);
    setOpenLogin(true);
  };

  /* ================= MOBILE VIEW ================= */
  if (isMobile) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#0f172a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Paper
          elevation={10}
          sx={{
            width: "100%",
            maxWidth: 420,
            borderRadius: 4,
            bgcolor: "#16223f",
            p: 2,
          }}
        >
          <LoginForm />
        </Paper>
      </Box>
    );
  }

  /* ================= DESKTOP VIEW ================= */
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#0f172a",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* WRAPPER */}
      <Box
        sx={{
          position: "relative",
          width: openLogin ? 880 : 500,
          height: 570,
          transition: "width 0.8s ease",
        }}
      >
        {/* IMAGE CARD */}
        <Paper
          elevation={10}
          sx={{
            width: 500,
            height: 565,
            borderRadius: 4,
            overflow: "hidden",
            position: "absolute",
            left: "50%",
            top: 0,
            zIndex: 2,
            boxShadow: `
              0 0 0 1px rgba(0, 180, 255, 0.25),
              0 0 25px rgba(0, 180, 255, 0.35),
              0 20px 60px rgba(0, 0, 0, 0.6)
            `,
            transform: openLogin
              ? "translateX(-510px)"
              : "translateX(-50%)",
            transition: "transform 0.8s ease",
          }}
        >
          <Box
            component="img"
            src={loginImage}
            alt="Login"
            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
          />

          <Typography
            sx={{
              position: "absolute",
              top: 24,
              left: 24,
              color: "#fff",
              fontSize: 16,
              fontWeight: 600,
            }}
          >
            Login to your Account
          </Typography>

          {!openLogin && (
            <Button
              variant="outlined"
              onClick={handleLoginClick}
              sx={{
                position: "absolute",
                top: 20,
                right: -21,
                color: "#fff",
                borderColor: "#fff",
                borderRadius: 20,
                px: 3,
                "&:hover": {
                  bgcolor: "#fff",
                  color: "#0284c7",
                },
              }}
            >
              Login
            </Button>
          )}
        </Paper>

        {/* LOGIN FORM CARD */}
        <Paper
          elevation={10}
          sx={{
            bgcolor: "#16223f",
            width: 500,
            height: 565,
            borderRadius: 4,
            position: "absolute",
            right: 0,
            top: 0,
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `
              0 0 0 1px rgba(0, 180, 255, 0.25),
              0 0 25px rgba(0, 180, 255, 0.35),
              0 20px 60px rgba(0, 0, 0, 0.6)
            `,
            transform: openLogin ? "translateX(0)" : "translateX(-20px)",
            opacity: openLogin ? 1 : 0,
            transition: `
              transform 2.6s cubic-bezier(0.16, 1, 0.3, 1) 0.6s,
              opacity 1.4s ease 0.7s
            `,
            pointerEvents: openLogin ? "auto" : "none",
          }}
        >
          <LoginForm />
        </Paper>
      </Box>
    </Box>
  );
};

export default Login;
